// extracted by mini-css-extract-plugin
export var chevron = "_4aSTj";
export var container = "W5h9G";
export var languageContainer = "aPLAg";
export var languageSelectValue = "_71Fp7";
export var logoWorld = "YnM+K";